import React, { useEffect, useState } from "react";
import { reduxForm, Field } from "redux-form";
import { Grid, Header, Divider, Button } from "semantic-ui-react";
import { renderTextField } from "../formcomponents";
import axios from "axios";
import { BaseUrlInvoice } from "../formcomponents/Constants";
import { useNavigate, useParams } from "react-router-dom";
import { userData } from "../store/userData";
import Swal from "sweetalert2";
const validate = (values) => {
  const errors = {};
  if (!values.workCategory) {
    errors.workCategory = "Required";
  }
  if (!values.openingBalance) {
    errors.openingBalance = "Required";
  }
  return errors;
};

const DailyWorkCatogery = (props) => {
  const { handleSubmit, pristine, reset, submitting } = props;
  const navigate = useNavigate();
  const { id } = useParams();
  const [buttonDisable, setbuttonDisable] = useState(false);
  const userDetail = userData();
  useEffect(() => {
    if (id !== "null") {
      if (userDetail.userRole != 1) {
        setbuttonDisable(true);
      }
      getWorkList();
    }
  }, []);
  const getWorkList = () => {
    axios
      .post(BaseUrlInvoice + "/accounts/listWorkCategory", { workCategory: "" })
      .then((res) => {
        console.log("res", res.data);
        const tempData = res.data;
        const filterData = tempData.filter((item) => item.categoryId == id);
        console.log("filterData", filterData);

        initilizeData(filterData);
      })
      .catch((error) => console.log(error));
  };

  const initilizeData = (filterData) => {
    props.initialize({
      categoryId: id,
      openingBalance: filterData[0].openingBalance,
      workCategory: filterData[0].workCategory,
    });
  };
  const sumbitForm = (values) => {
    console.log(values);
    axios
      .post(BaseUrlInvoice + "accounts/createWorkCategory", values)
      .then((res) => {
        console.log("res", res.data);
        if (res.data.errCode === 200) {
          Swal.fire({
            icon: "success",
            title: "sccess",
            text: "Created",
          });
          navigate(-1);
        }
      })
      .catch((error) => {
        console.log(error.response.status);
        if (error.response.status === "500") {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "This Work Type Already Created",
          });
        }
      });
  };
  return (
    <div>
      <Grid.Row>
        <Header dividing size="huge" as="h1">
          Create Work Category
        </Header>
      </Grid.Row>
      <Divider hidden /> <Divider hidden />
      <Grid.Row>
        <Grid columns="two">
          <Grid.Row>
            <Grid.Column>
              <Field
                name="workCategory"
                label="Work Category"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="openingBalance"
                label="Opening Balance"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Row>
      <Divider hidden />
      <Button
        floated="right"
        positive
        disabled={buttonDisable}
        onClick={handleSubmit((values) =>
          sumbitForm({
            ...values,
          })
        )}
      >
        Save
      </Button>
      <Button
        floated="right"
        negative
        disabled={pristine || submitting}
        onClick={reset}
      >
        Cancel
      </Button>
    </div>
  );
};

export default reduxForm({
  form: "DailyWorkCatogery",
  validate,
})(DailyWorkCatogery);
